import Logo from 'assets/images/logo.svg';

import { MouseEvent, FC, useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
// Components
// Types
import UserRoles from 'app/types/UserRoles';
// Models
import { IMyUser } from 'app/models/User';
// Redux
import { useAppSelector } from 'app/hooks/useStore';
// Selectors
import { selectMyUser } from 'app/store/Users/Users.selectors';
// Mui
import { Box, Divider, Tooltip } from '@mui/material';
// i18next
import { useTranslation } from 'react-i18next';
import { selectTrialMode } from 'app/store/AppUI/AppUI.selectors';

const Brand:FC = () => {
  const { t } = useTranslation();

  const { pathname } = useLocation<{ pathname:string; }>();

  // State
  const trialMode = useAppSelector(selectTrialMode);
  const myUser:IMyUser | null = useAppSelector(selectMyUser);

  const to = useMemo(() => {
    if ( !myUser ) return '';
    return myUser?.role === UserRoles.Admin || myUser?.role === UserRoles.Staff
      ? '/admin/cases'
      : myUser?.role === UserRoles.Presenter || myUser?.role === UserRoles.Client
        ? '/presenter/cases'
        : '/am/accounts'
    ;
  }, [myUser]);

  const handleClick = (event:MouseEvent) => {
    console.log(pathname, to);
    if ( !myUser || trialMode || pathname === to ){
      event.preventDefault();
    };
  }

  const boxProps = !myUser || trialMode ? {
    sx: {
      cursor: 'default',
      pointerEvents: 'none',
    },
  } : {
    sx: {
      cursor: 'pointer',
    },
    to: to,
    component: Link,
    onClick: handleClick,
  };

  return (
    <Tooltip title={!myUser || trialMode ? '' : t('components.brand.home')}>
      <Box
        {...boxProps}
        sx={{
          display: 'flex',
          alignItems: 'center',
          textDecoration: 'none',
        }}
      >
        <img src={Logo} alt={`Case Chronology - ${t('components.brand.casePortal')}`} />
        <Divider
          sx={{
            height: 40,
            mx: 4
          }}
          orientation="vertical"
        />
        <Box
          sx={{
            color: 'rgba(0,0,0,0.6)',
            fontWeight: 500,
            fontSize: 20,
            lineHeight: '24px',
            letterSpacing: '0.15px'
          }}
          component="span"
        >{t('components.brand.casePortal')}</Box>
      </Box>
    </Tooltip>
  );
}

export default Brand;
